export default __webpack_public_path__ + "static/media/T3_02.5e981cc7.jpg";